module.exports = __webpack_public_path__ + "static/img/noData.7f2e758b.png";